skrilla.controller('promotionsCtrl', function ($scope, cacheService, modalService, dateService, searchService, queryService, srefService, adminService, currencyService) {
    $scope.key = "promotions";
    $scope.promotions = cacheService.getObjectOrElse("promotionsTable", []);
    $scope.hasRole = adminService.hasRole;

    $scope.tabs = [
        {title: "Promotions", active: true},
        {title: "Affiliates", active: false},
        {title: "BTAG Referral Promotions", active: false},
        {title: "Campaigns", active: false}
    ];

    $scope.route = function(promotion){
        srefService.go("promotionDetails", {id: promotion.id})
    }

    $scope.onCampaignClick = function(campaign){
        srefService.go("campaignDetails", {id: campaign.id})
    }

    $scope.create = function(){
        modalService.openModal("views/createPromotionDefinition/createPromotionDefinition.html", true, 'lg', false, true , function(){
            cacheService.wipeObject("promotionPurpose")
        });
    }
    $scope.createCampaign = function(){
        modalService.openModal("views/campaignDetails/createCampaignModal.html", true, 'lg', false, true , function(){
            cacheService.wipeObject("promotionPurpose")
        });
    }

    $scope.createBtagReferralCode = function () {
        cacheService.registerObject("promotionPurpose", 'BTAG_REFERRAL')
        $scope.create()
    }

});
